import { i18n } from '@/i18n';
import { ForecastForReceiptActionType, ForecastForReceiptMenuItems } from '../entities/ForecastForReceiptMenu';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';

/**
 * 受領用内示メニューのアイテム用のサービス
 */
export class ForecastForReceiptMenuService {
  /**
   * 受領用内示メニューのアイテムが新規作成かどうか
   * @param item - 受領用内示メニューのアイテム
   * @returns true: 新規作成, false: 新規作成ではない
   */
  static isCreateForecastForReceipt = (item: ForecastForReceiptMenuItems): boolean => {
    return item === 'CreateForecastForReceipt';
  };

  /**
   * 受領用内示メニューのアイテムが追加かどうか
   * @param item - 受領用内示メニューのアイテム
   * @returns true: 追加, false: 追加ではない
   */
  static isAddBaseBusinessToForecastForReceipt = (item: ForecastForReceiptMenuItems): boolean => {
    return item === 'AddBaseBusinessToForecastForReceipt';
  };

  /**
   * 受領用内示メニューのアイテムが編集かどうか
   * @param item - 受領用内示メニューのアイテム
   * @returns true: 編集, false: 編集ではない
   */
  static isEditForecastForReceipt = (item: ForecastForReceiptMenuItems): boolean => {
    return item === 'EditForecastForReceipt';
  };

  /**
   * 受領用内示メニューのアイテムの表示名を取得する
   * @param item - 受領用内示メニューのアイテム
   * @returns 受領用内示メニューのアイテムの表示名
   */
  static getDisplayText = (item: ForecastForReceiptMenuItems): string => {
    const t = i18n.t;
    switch (item) {
      case 'CreateForecastForReceipt':
        return t('新規作成');
      case 'AddBaseBusinessToForecastForReceipt':
        return t('受領用内示に取引を追加');
      case 'EditForecastForReceipt':
        return t('受領用内示情報を編集');
    }
  };

  /**
   * 受領用内示メニューのアイテムのローディング中のテキストを取得する
   * @param item - 受領用内示メニューのアイテム
   * @returns 受領用内示メニューのアイテムのローディング中のテキスト
   */
  static getLoadingText = (item: ForecastForReceiptActionType): string => {
    const t = i18n.t;
    switch (item) {
      case 'create':
        return t('受領用内示の新規作成中');
      case 'delete':
        return t('受領用内示を削除中');
      case 'updateForecastForReceipt':
        return t('受領用内示情報を更新中');
      case 'addBaseBusiness':
        return t('関連取引を受領用内示に追加中');
      case 'deleteBaseBusiness':
        return t('関連取引を受領用内示から連携解除中');
      default:
        return '';
    }
  };

  /**
   * 操作後にリロードが必要かどうか
   * @param item - 受領用内示メニューのアイテム
   * @returns true: リロードが必要, false: リロードが不要
   */
  static needReloadOnAfterAction = (item: ForecastForReceiptActionType): boolean => {
    return item === 'create' || item === 'delete' || item === 'updateForecastForReceipt';
  };

  /**
   * 取引が関係する受領用内示メニューのアイテムかどうか
   * @param item - 受領用内示メニューのアイテム
   * @returns true: 取引が関係する受領用内示メニューのアイテム, false: 取引が関係しない受領用内示メニューのアイテム
   */
  static isBaseBusinessRelatedItem = (item: ForecastForReceiptMenuItems): boolean => {
    return item === 'AddBaseBusinessToForecastForReceipt';
  };

  /**
   * FilterContentItemを取得する
   * @param selectedForecastForReceiptId - 選択された受領用内示のID
   * @returns FilterContentItem
   */
  static getFilterContentItem = (selectedForecastForReceiptId: string): FilterContentItem => {
    const t = i18n.t;
    return {
      filterType: 'FORECAST_FOR_RECEIPT_ID',
      selectedValue: [selectedForecastForReceiptId],
      label: t('受領用内示'),
    };
  };
}
